// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── ResultsView — Premium Editorial Layout ─── */
.ResultsView_results__aXu\\+3 {
  width: full;
  margin: 0;
  padding: 0;
  /* Opacity-only fade: a \`transform\` here would become the containing block for
     the fixed rail / admin panel and make them scroll with the page. */
  animation: ResultsView_resultsFadeIn__SRSjy 0.4s ease-out both;
  position: relative;
}

@keyframes ResultsView_resultsFadeIn__SRSjy {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* ─── 2-Column Layout: Sticky Sidebar + Main ─── */
.ResultsView_layout__y0Mmy {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding: 16px 20px 40px;
  box-sizing: border-box;
}

/* ─── Sticky Left Sidebar ─── */
.ResultsView_sidebar__Wdw9\\+ {
  flex: 0 0 320px;
  width: 320px;
  align-self: stretch;
  min-width: 0;
  min-height: calc(100vh - var(--navbar-height, 64px) - 24px);
}

.ResultsView_sidebar-sticky__bgfnJ {
  position: sticky;
  top: calc(var(--navbar-height, 64px) + 16px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: calc(100vh - var(--navbar-height, 64px) - 24px);
  padding-right: 4px;
}

.ResultsView_sidebar-head__Xyk5e {
  padding: 0 4px;
}

.ResultsView_sidebar-eyebrow__0zl6p {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  color: var(--accent-color, #0f3460);
  opacity: 0.75;
}

/* ─── Right Main Content ─── */
.ResultsView_main__W4UCN {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* ─── Overview / Ranking sub-tabs (Research Topics Overview mode) ─── */
.ResultsView_overview-tabs__J9t8U {
  min-height: 40px;
  border-bottom: 1px solid rgba(15, 52, 96, 0.12);
  margin-top: -16px;
}
.ResultsView_overview-tabs__J9t8U .MuiTabs-flexContainer {
  gap: 4px;
}

.ResultsView_overview-tabs-indicator__fOBVW {
  background-color: #0f3460;
  height: 2px;
}

.ResultsView_overview-tab__9Glpy {
  min-height: 40px;
  padding: 8px 22px;
  font-size: 14px;
  font-weight: 600;
  color: var(--grey-text, #64748b);
}
.ResultsView_overview-tab--selected__vVtiU, .ResultsView_overview-tab__9Glpy.Mui-selected {
  color: #0f3460 !important;
}

/* ─── Section 2: Benchmark Results ─── */
.ResultsView_benchmark-results-section__tv4dT {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.ResultsView_section-head__E65Pg {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ResultsView_section-eyebrow__72Wbp {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: var(--accent-color, #0f3460);
  opacity: 0.75;
}

.ResultsView_section-title__7zzaI {
  margin: 0;
  font-family: "Lora", "Georgia", serif;
  font-size: 22px;
  font-weight: 700;
  color: var(--text-1, #1a1a1a);
}

.ResultsView_section-subtitle__jtuS3 {
  margin: 0;
  font-size: 13px;
  color: var(--grey-text, #64748b);
  line-height: 1.5;
}

/* ─── Empty Chart State ─── */
.ResultsView_empty-chart-state__u4dgn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 60px 24px;
  background: var(--bg-2, #fff);
  border: 1px dashed rgba(15, 52, 96, 0.18);
  border-radius: 14px;
  text-align: center;
}
.ResultsView_empty-chart-state__icon__jENG5 {
  color: var(--accent-color, #0f3460);
  opacity: 0.5;
}
.ResultsView_empty-chart-state__title__OTv0f {
  margin: 0;
  font-family: "Lora", "Georgia", serif;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-1, #1a1a1a);
}
.ResultsView_empty-chart-state__text__OnxBu {
  margin: 0;
  max-width: 480px;
  font-size: 13px;
  color: var(--grey-text, #64748b);
  line-height: 1.55;
}
.ResultsView_empty-chart-state__text__OnxBu strong {
  color: var(--accent-color, #0f3460);
}

/* ─── Top Row: Filter + Charts side by side ─── */
.ResultsView_top-row__pi0rJ {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

/* ─── Charts Column ─── */
.ResultsView_charts-column__Namsd {
  flex: 0 0 65%;
  max-width: 65%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}

/* ─── Bottom Section (full-width table) ─── */
.ResultsView_bottom-section__wgkEo {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

@keyframes ResultsView_fadeIn__7wb9m {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* ─── Hero Header ─── */
.ResultsView_hero__kydjT {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 20px 16px 0;
}

/* ─── Divider ─── */
.ResultsView_divider__A-m\\+6 {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.08) 20%, rgba(0, 0, 0, 0.08) 80%, transparent 100%);
}

/* ─── Filter Bar (vertical, in sidebar) ─── */
.ResultsView_filter-bar__LgDLl {
  background: var(--bg-2, #fff);
  border-radius: 14px;
  padding: 20px 18px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  gap: 18px;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  overflow-y: auto;
}
.ResultsView_filter-bar__LgDLl::-webkit-scrollbar {
  width: 6px;
}
.ResultsView_filter-bar__LgDLl::-webkit-scrollbar-thumb {
  background: rgba(15, 52, 96, 0.15);
  border-radius: 4px;
}

/* ─── Mode RadioGroup ─── */
.ResultsView_mode-radio-group__DitTQ {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin: 0;
}

.ResultsView_mode-radio-row__Rs3\\+n {
  margin: 0;
  padding: 2px 0;
}

.ResultsView_mode-radio-label__S-Lbg {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-1, #1a1a2e);
  line-height: 1.3;
}

/* ─── Sidebar action buttons ─── */
.ResultsView_sidebar-actions__HED3o {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid rgba(15, 52, 96, 0.08);
}

.ResultsView_results-wrapper__EsJEJ {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.ResultsView_filter-group__uOpbj {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ResultsView_filter-label-row__AahgE {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.ResultsView_filter-label__Uil7E {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: var(--accent-color, #0f3460);
}

.ResultsView_filter-hint__2Ekps {
  font-size: 12px;
  font-weight: 400;
  font-style: italic;
  color: var(--grey-text, #999);
}

/* ─── Chip Search Bar ─── */
.ResultsView_chip-search__zqAM0 {
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  background: var(--bg-1, #fafafa);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 8px 12px;
  align-content: flex-start;
  transition: box-shadow 0.25s, border-color 0.25s;
}
.ResultsView_chip-search__zqAM0:focus-within {
  border-color: rgba(15, 52, 96, 0.25);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}
.ResultsView_chip-search__icon__yi9pY {
  flex-shrink: 0;
  color: #94a3b8;
}
.ResultsView_chip-search__chip__-3oU7 {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 10px;
  background: #0f3460;
  color: #fff;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  animation: ResultsView_chipIn__nNJqU 0.2s ease-out;
  min-width: 0;
  max-width: 100%;
}
.ResultsView_chip-search__chip-text__fgxwP {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.ResultsView_chip-search__chip-remove__zcKuS {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border: none;
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s;
  padding: 0;
}
.ResultsView_chip-search__chip-remove__zcKuS:hover {
  background: rgba(255, 255, 255, 0.45);
}
.ResultsView_chip-search__input__L6GBD {
  flex: 1 1 120px;
  min-width: 120px;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: var(--text-1, #1a1a2e);
  padding: 4px 2px;
}
.ResultsView_chip-search__input__L6GBD::placeholder {
  color: #94a3b8;
  font-weight: 400;
}
.ResultsView_chip-search__zqAM0 {
  /* Suggestions dropdown */
}
.ResultsView_chip-search__suggestions__S9GG\\+ {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
  z-index: 100;
  max-height: 220px;
  overflow-y: auto;
  padding: 4px;
  animation: ResultsView_dropIn__3wgbn 0.15s ease-out;
}
.ResultsView_chip-search__suggestion-item__d1pgc {
  display: block;
  width: 100%;
  text-align: left;
  padding: 9px 12px;
  border: none;
  background: transparent;
  font-size: 13px;
  color: var(--text-1, #1a1a2e);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.12s;
}
.ResultsView_chip-search__suggestion-item__d1pgc:hover {
  background: rgba(15, 52, 96, 0.06);
}

/* ─── Back Button ─── */
.ResultsView_back-btn__4ET9p {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 0;
  border: none;
  background: none;
  color: var(--accent-color, #0f3460);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
  align-self: flex-start;
}
.ResultsView_back-btn__4ET9p:hover {
  opacity: 0.65;
}

/* ─── Analyze Button ─── */
.ResultsView_analyze-btn__iVja6 {
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 22px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #1e3a5f 0%, #0f3460 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 14px rgba(15, 52, 96, 0.2);
}
.ResultsView_analyze-btn__iVja6:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 22px rgba(15, 52, 96, 0.35);
  filter: brightness(1.1);
}
.ResultsView_analyze-btn__iVja6:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(15, 52, 96, 0.2);
}
.ResultsView_analyze-btn__iVja6:disabled {
  background: #e8e8e8;
  color: #aaa;
  cursor: not-allowed;
  box-shadow: none;
}

/* ─── Spin ─── */
.ResultsView_spin__1C9es {
  animation: ResultsView_spin__1C9es 0.8s linear infinite;
}

@keyframes ResultsView_spin__1C9es {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes ResultsView_chipIn__nNJqU {
  from {
    opacity: 0;
    transform: scale(0.85);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes ResultsView_dropIn__3wgbn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* ─── Export Bar ─── */
.ResultsView_export-bar__V5Jik {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.ResultsView_export-btn__MGdQ6 {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 18px;
  border-radius: 10px;
  border: 1px solid rgba(15, 52, 96, 0.15);
  background: rgba(15, 52, 96, 0.04);
  color: #0f3460;
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.2px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.ResultsView_export-btn__MGdQ6:hover:not(:disabled) {
  background: rgba(15, 52, 96, 0.1);
  border-color: rgba(15, 52, 96, 0.25);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(15, 52, 96, 0.12);
}
.ResultsView_export-btn__MGdQ6:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: none;
}
.ResultsView_export-btn__MGdQ6:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.ResultsView_export-btn--excel__JX4E- {
  border-color: rgba(16, 124, 65, 0.2);
  background: rgba(16, 124, 65, 0.04);
  color: #107c41;
}
.ResultsView_export-btn--excel__JX4E-:hover:not(:disabled) {
  background: rgba(16, 124, 65, 0.1);
  border-color: rgba(16, 124, 65, 0.3);
  box-shadow: 0 4px 12px rgba(16, 124, 65, 0.12);
}
.ResultsView_export-btn--full__dGWIQ {
  width: 100%;
  justify-content: center;
}

/* ─── Skeleton ─── */
.ResultsView_skeleton-wrapper__36SQy {
  padding: 32px 28px;
  background: var(--bg-2, #fff);
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

/* ─── Error ─── */
.ResultsView_error-msg__taIXW {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 60px 20px;
  text-align: center;
  background: var(--bg-2, #fff);
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}
.ResultsView_error-msg__icon__-ByLq {
  font-size: 32px;
  opacity: 0.6;
}
.ResultsView_error-msg__text__VOM8E {
  color: #ff4d4f;
  font-size: 14px;
  font-weight: 500;
}

/* Inter-Institutional Metric Scaling: title → full-name legend → bar + pie */
.ResultsView_benchmark-scaling-head__f3Ihs {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 14px;
}

.ResultsView_benchmark-scaling-legend__uZgtO {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 20px;
}

.ResultsView_benchmark-scaling-legend__item__ZlL8M {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.ResultsView_benchmark-scaling-legend__swatch__hpLlM {
  width: 14px;
  height: 14px;
  border-radius: 2px;
  flex-shrink: 0;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.ResultsView_benchmark-scaling-legend__name__2K\\+gA {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-1, #333);
  line-height: 1.35;
}

.ResultsView_scaling-chart-block__W6wyR {
  margin-top: 4px;
  margin-bottom: 24px;
}

.ResultsView_scaling-chart-grid__3M\\+Q\\+ {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  align-items: start;
}

.ResultsView_scaling-chart-block__label__BUGee {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #0f3460;
}

.ResultsView_chart-viz-tabpane__zzbhU {
  padding-top: 10px;
  font-size: 15px;
  color: #0f3460;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

.ResultsView_advanced-benchmark__1HO4Q {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 2px;
}

.ResultsView_advanced-benchmark__head__\\+r2zw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(15, 52, 96, 0.08);
}

.ResultsView_advanced-benchmark__title__6g-rF {
  margin: 0;
  font-family: "Lora", "Georgia", serif;
  font-size: 22px;
  font-weight: 700;
  color: var(--text-1, #1a1a1a);
}

.ResultsView_advanced-benchmark__grid__u8CyJ {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 20px;
  align-items: start;
}

.ResultsView_advanced-benchmark__split-cell__OIV7A {
  min-width: 0;
}

.ResultsView_advanced-benchmark__item--wide__IZvoL {
  grid-column: span 12;
}

.ResultsView_advanced-benchmark__item--half__xkXjO {
  grid-column: span 6;
}

/* Off-screen PDF capture (html2canvas); not visible to users */
.ResultsView_pdf-capture-host__V9jYP {
  position: sticky;
  left: -20000px;
  top: 0;
  width: 1200px;
  pointer-events: none;
}

.ResultsView_pdf-summary__Zzx9K {
  background: #fff;
  padding: 28px 32px 36px;
  box-sizing: border-box;
  font-family: "Poppins", system-ui, sans-serif;
  color: #1a1a1a;
}
.ResultsView_pdf-summary__intro__rxXBe {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 28px;
}
.ResultsView_pdf-summary__title__VII4d {
  font-family: "Lora", "Georgia", serif;
  font-size: 22px;
  font-weight: 700;
  margin: 0;
  color: #1a1a1a;
}
.ResultsView_pdf-summary__subtitle__cMxvd {
  margin: 0;
  font-size: 13px;
  color: #666;
  line-height: 1.45;
  max-width: 720px;
}
.ResultsView_pdf-summary__legend__CYZYq {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  margin-bottom: 28px;
  padding-top: 4px;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.ResultsView_pdf-summary__legend-item__tD3gp {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
}
.ResultsView_pdf-summary__swatch__gcTYD {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  flex-shrink: 0;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.ResultsView_pdf-summary__legend-name__KA\\+m4 {
  font-size: 14px;
  font-weight: 600;
  color: #0f3460;
  line-height: 1.3;
}
.ResultsView_pdf-summary__table__NTpNv {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  table-layout: fixed;
}
.ResultsView_pdf-summary__table__NTpNv th,
.ResultsView_pdf-summary__table__NTpNv td {
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px 12px;
  text-align: right;
  vertical-align: top;
  word-wrap: break-word;
}
.ResultsView_pdf-summary__table__NTpNv th[scope=col]:first-child,
.ResultsView_pdf-summary__table__NTpNv th[scope=row],
.ResultsView_pdf-summary__table__NTpNv td:first-child {
  text-align: left;
  font-weight: 600;
  background: rgba(15, 52, 96, 0.04);
}
.ResultsView_pdf-summary__table__NTpNv thead th {
  font-weight: 700;
  color: #0f3460;
  background: rgba(15, 52, 96, 0.08);
}

.ResultsView_pdf-pie-capture__aQnVk {
  width: 100%;
  max-width: 1200px;
  background: #fff;
  box-sizing: border-box;
}

/* ─── Responsive ─── */
@media only screen and (max-width: 1100px) {
  .ResultsView_layout__y0Mmy {
    flex-direction: column;
    gap: 20px;
    padding: 12px 16px 32px;
  }
  .ResultsView_sidebar__Wdw9\\+ {
    flex: none;
    width: 100%;
  }
  .ResultsView_sidebar-sticky__bgfnJ {
    position: static;
    height: auto;
  }
  .ResultsView_main__W4UCN {
    width: 100%;
  }
}
@media only screen and (max-width: 960px) {
  .ResultsView_scaling-chart-grid__3M\\+Q\\+ {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .ResultsView_top-row__pi0rJ {
    flex-direction: column;
  }
  .ResultsView_charts-column__Namsd {
    flex: none;
    max-width: 100%;
    width: 100%;
  }
  .ResultsView_advanced-benchmark__grid__u8CyJ {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .ResultsView_advanced-benchmark__item--wide__IZvoL,
  .ResultsView_advanced-benchmark__item--half__xkXjO {
    grid-column: span 6;
  }
}
@media only screen and (max-width: 768px) {
  .ResultsView_layout__y0Mmy {
    padding: 8px 12px 24px;
    gap: 16px;
  }
  .ResultsView_hero__kydjT {
    padding: 12px 12px 0;
  }
  .ResultsView_filter-bar__LgDLl {
    padding: 16px 14px;
    border-radius: 12px;
  }
  .ResultsView_chip-search__zqAM0 {
    padding: 6px 10px;
  }
  .ResultsView_analyze-btn__iVja6 {
    width: 100%;
    max-width: none;
    justify-content: center;
  }
}
/* ─────────────────────────────────────────────────────────────────────────
   Revamped layout: sticky header + collapsible mode rail + floating pair panel
   ───────────────────────────────────────────────────────────────────────── */
.ResultsView_topbar__heiyu {
  position: fixed;
  top: var(--navbar-height, 60px);
  left: 0;
  right: 0;
  z-index: 20;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px 24px;
  padding: 14px 20px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.05);
}

.ResultsView_topbar__topics__v1248 {
  flex: 1 1 420px;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ResultsView_topbar__controls__DCSWX {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 16px;
}

.ResultsView_topbar__group__8foQd {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ResultsView_topbar__actions__jehXw {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ResultsView_topbar__actions__jehXw .ResultsView_analyze-btn__iVja6 {
  align-self: center;
  padding: 10px 20px;
}
.ResultsView_topbar__actions__jehXw .ResultsView_export-btn__MGdQ6 {
  padding: 9px 14px;
}

/* Segmented time-range control */
.ResultsView_timeseg__V-nN8 {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  background: #eef2f6;
  border-radius: 10px;
}

.ResultsView_timeseg__btn__weffX {
  border: none;
  background: transparent;
  padding: 7px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s, box-shadow 0.15s;
}
.ResultsView_timeseg__btn__weffX:hover {
  color: #0f3460;
}

.ResultsView_timeseg__btn--active__gOca1 {
  background: #fff;
  color: #0f3460;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.14);
}

.ResultsView_workspace__iBsIt {
  /* Header is sticky (in flow) so it needs no top offset; the left offset (set
     inline = rail width + gap) clears the fixed rail. 316px is the fallback. */
  padding: 24px 20px 48px 316px;
  box-sizing: border-box;
}

/* ─── Benchmark-mode rail (dark, collapsible) ─── */
.ResultsView_rail__xTTVi {
  /* Fixed to the viewport (below the fixed topbar). Exact top/height are set
     inline from the measured header height so it clears the header precisely. */
  position: fixed;
  left: 20px;
  top: 180px;
  z-index: 15;
  width: 272px;
  height: calc(100vh - 220px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 10px;
  background: #0f2138;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.14);
  transition: flex-basis 0.2s ease, width 0.2s ease;
}
.ResultsView_rail__xTTVi::-webkit-scrollbar {
  width: 6px;
}
.ResultsView_rail__xTTVi::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}

.ResultsView_rail--collapsed__Sw-mW {
  flex-basis: 68px;
  width: 68px;
}
.ResultsView_rail--collapsed__Sw-mW .ResultsView_rail__head__6DmpZ {
  justify-content: center;
}
.ResultsView_rail--collapsed__Sw-mW .ResultsView_rail__item__MycCH {
  justify-content: center;
  padding: 10px;
}

.ResultsView_rail__head__6DmpZ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 4px 6px 8px;
}

.ResultsView_rail__eyebrow__YPRvO {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: #64748b;
}

.ResultsView_rail__toggle__8chB1 {
  margin-left: auto;
  border: none;
  background: transparent;
  color: #94a3b8;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  padding: 3px 7px;
  border-radius: 6px;
  transition: background 0.15s, color 0.15s;
}
.ResultsView_rail__toggle__8chB1:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

.ResultsView_rail__list__z7dff {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ResultsView_rail__item__MycCH {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  background: transparent;
  border-radius: 10px;
  color: #cbd5e1;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.ResultsView_rail__item__MycCH:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
}

.ResultsView_rail__item--active__RpiLV {
  background: linear-gradient(135deg, #f0703a 0%, #e8622c 100%);
  color: #fff;
  box-shadow: 0 6px 16px rgba(232, 98, 44, 0.35);
}
.ResultsView_rail__item--active__RpiLV:hover {
  background: linear-gradient(135deg, #f0703a 0%, #e8622c 100%);
  color: #fff;
}
.ResultsView_rail__item--active__RpiLV .ResultsView_rail__icon__ZWpOe {
  color: #fff;
}

.ResultsView_rail__icon__ZWpOe {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: #94a3b8;
}

.ResultsView_rail__label__wc3ws {
  white-space: nowrap;
}

/* ─── Results column: pair picker (own row) + charts ─── */
.ResultsView_content-col__sOY\\+O {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
  width: 100%;
  /* Padding so charts don't sit flush against the scrollbar when this column
     becomes the bounded scroll container (inline height on wide screens). */
  padding-right: 4px;
  padding-bottom: 24px;
  scrollbar-gutter: stable;
}
.ResultsView_content-col__sOY\\+O::-webkit-scrollbar {
  width: 8px;
}
.ResultsView_content-col__sOY\\+O::-webkit-scrollbar-thumb {
  background: rgba(15, 52, 96, 0.18);
  border-radius: 4px;
}

/* Pair-entity picker card — its own row, aligned with the results column */
.ResultsView_pair-panel__V-gsI {
  align-self: flex-start;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);
}

/* ─── Report builder: per-chart "Add to report" toggle ─── */
.ResultsView_reportable__7NcW4 {
  position: relative;
}

.ResultsView_report-toggle__Sq2Jc {
  position: absolute;
  top: 10px;
  right: 12px;
  z-index: 6;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 11px;
  border: 1px solid rgba(15, 52, 96, 0.22);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(2px);
  color: #0f3460;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);
  transition: background 0.15s, border-color 0.15s, color 0.15s, box-shadow 0.15s;
}
.ResultsView_report-toggle__Sq2Jc:hover {
  border-color: rgba(15, 52, 96, 0.4);
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.12);
}

.ResultsView_report-toggle--on__DRldb {
  background: linear-gradient(135deg, #f0703a 0%, #e8622c 100%);
  border-color: transparent;
  color: #fff;
  box-shadow: 0 4px 12px rgba(232, 98, 44, 0.32);
}
.ResultsView_report-toggle--on__DRldb:hover {
  border-color: transparent;
  box-shadow: 0 5px 14px rgba(232, 98, 44, 0.4);
}

/* ─── Report preview modal ─── */
.ResultsView_report-preview__kHYAX {
  max-height: 62vh;
  overflow-y: auto;
}
.ResultsView_report-preview__loading__brFJx {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 0;
  color: #64748b;
  font-size: 14px;
}
.ResultsView_report-preview__empty__E8FCK {
  padding: 40px 0;
  text-align: center;
  color: #64748b;
  font-size: 14px;
}
.ResultsView_report-preview__hint__8jFer {
  margin: 0 0 16px;
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
}
.ResultsView_report-preview__item__lEIcq {
  margin-bottom: 20px;
}
.ResultsView_report-preview__item__lEIcq:last-child {
  margin-bottom: 0;
}
.ResultsView_report-preview__item-title__STzcR {
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
}
.ResultsView_report-preview__img__egLdz {
  display: block;
  width: 100%;
  height: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.ResultsView_report-preview__legend__VEUJx {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
  margin-top: 10px;
}
.ResultsView_report-preview__legend-item__WhzQR {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #475569;
}
.ResultsView_report-preview__legend-swatch__Lh9JF {
  width: 11px;
  height: 11px;
  border-radius: 3px;
  flex-shrink: 0;
}
.ResultsView_report-preview__table-wrap__lx\\+f1 {
  margin-top: 10px;
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.ResultsView_report-preview__table__XlK6O {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.ResultsView_report-preview__table__XlK6O th,
.ResultsView_report-preview__table__XlK6O td {
  padding: 7px 10px;
  border-bottom: 1px solid #eef2f6;
  white-space: nowrap;
}
.ResultsView_report-preview__table__XlK6O th {
  background: #f8fafc;
  font-weight: 700;
  color: #334155;
}
.ResultsView_report-preview__table__XlK6O td {
  color: #475569;
}
.ResultsView_report-preview__table__XlK6O tr:last-child td {
  border-bottom: none;
}

/* Small screens: unpin the header + rail, drop the offsets */
@media only screen and (max-width: 960px) {
  .ResultsView_topbar__heiyu {
    position: static;
  }
  .ResultsView_rail__xTTVi {
    position: static;
    top: auto;
    height: auto;
    width: 100%;
    margin-bottom: 16px;
  }
  .ResultsView_rail--collapsed__Sw-mW {
    width: 100%;
  }
  .ResultsView_workspace__iBsIt {
    padding-top: 20px;
    padding-left: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/ResultsView/ResultsView.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,mDAAA;AAEA;EACE,WAAA;EACA,SAAA;EACA,UAAA;EACA;uEAAA;EAEA,8DAAA;EACA,kBAAA;AACF;;AAEA;EACE;IACE,UAAA;EACF;EACA;IACE,UAAA;EACF;AACF;AAEA,mDAAA;AACA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;EACA,sBAAA;AAAF;;AAGA,gCAAA;AACA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,2DAAA;AAAF;;AAGA;EACE,gBAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uDAAA;EACA,kBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mCAAA;EACA,aAAA;AAAF;;AAGA,+BAAA;AACA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA,wEAAA;AACA;EACE,gBAAA;EACA,+CAAA;EACA,iBAAA;AAAF;AAEE;EACE,QAAA;AAAJ;;AAIA;EACE,yBAAA;EACA,WAAA;AADF;;AAIA;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AADF;AAGE;EAEE,yBAAA;AAFJ;;AAMA,yCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,yCAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mCAAA;EACA,aAAA;AAHF;;AAMA;EACE,SAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AAHF;;AAMA;EACE,SAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;AAHF;;AAMA,8BAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,yCAAA;EACA,mBAAA;EACA,kBAAA;AAHF;AAKE;EACE,mCAAA;EACA,YAAA;AAHJ;AAME;EACE,SAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AAJJ;AAOE;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,iBAAA;AALJ;AAOI;EACE,mCAAA;AALN;;AAUA,kDAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AAPF;;AAUA,0BAAA;AACA;EACE,aAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAPF;;AAUA,8CAAA;AACA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAPF;;AAUA;EACE;IACE,UAAA;IACA,2BAAA;EAPF;EAUA;IACE,UAAA;IACA,wBAAA;EARF;AACF;AAWA,wBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,oBAAA;AATF;;AAYA,oBAAA;AACA;EACE,WAAA;EACA,WAAA;EACA,sHAAA;AATF;;AAgBA,8CAAA;AACA;EACE,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,wEAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AAbF;AAeE;EACE,UAAA;AAbJ;AAgBE;EACE,kCAAA;EACA,kBAAA;AAdJ;;AAkBA,4BAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;EACA,SAAA;AAfF;;AAkBA;EACE,SAAA;EACA,cAAA;AAfF;;AAkBA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;AAfF;;AAkBA,mCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,4CAAA;AAfF;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAfF;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAfF;;AAkBA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;AAfF;;AAkBA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mCAAA;AAfF;;AAkBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;AAfF;;AAkBA,4BAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,WAAA;EACA,gCAAA;EACA,qCAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gDAAA;AAfF;AAiBE;EACE,oCAAA;EACA,0CAAA;AAfJ;AAkBE;EACE,cAAA;EACA,cAAA;AAhBJ;AAmBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kDAAA;EACA,YAAA;EACA,eAAA;AAjBJ;AAoBE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAlBJ;AAqBE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,qCAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;EACA,UAAA;AAnBJ;AAqBI;EACE,qCAAA;AAnBN;AAuBE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;AArBJ;AAuBI;EACE,cAAA;EACA,gBAAA;AArBN;AA5DA;EAqFE,yBAAA;AAtBF;AAuBE;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,2CAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,mDAAA;AArBJ;AAwBE;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;AAtBJ;AAwBI;EACE,kCAAA;AAtBN;;AA2BA,wBAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,sBAAA;AAxBF;AA0BE;EACE,aAAA;AAxBJ;;AA4BA,2BAAA;AACA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,6DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,kDAAA;EACA,4CAAA;AAzBF;AA2BE;EACE,2BAAA;EACA,6CAAA;EACA,uBAAA;AAzBJ;AA4BE;EACE,wBAAA;EACA,2CAAA;AA1BJ;AA6BE;EACE,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AA3BJ;;AA+BA,iBAAA;AACA;EACE,uDAAA;AA5BF;;AA+BA;EACE;IACE,uBAAA;EA5BF;EA+BA;IACE,yBAAA;EA7BF;AACF;AAgCA;EACE;IACE,UAAA;IACA,sBAAA;EA9BF;EAiCA;IACE,UAAA;IACA,mBAAA;EA/BF;AACF;AAkCA;EACE;IACE,UAAA;IACA,2BAAA;EAhCF;EAmCA;IACE,UAAA;IACA,wBAAA;EAjCF;AACF;AAsCA,uBAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AApCF;;AAuCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,wCAAA;EACA,kCAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AApCF;AAsCE;EACE,iCAAA;EACA,oCAAA;EACA,2BAAA;EACA,6CAAA;AApCJ;AAuCE;EACE,wBAAA;EACA,gBAAA;AArCJ;AAwCE;EACE,YAAA;EACA,mBAAA;AAtCJ;AAyCE;EACE,oCAAA;EACA,mCAAA;EACA,cAAA;AAvCJ;AAyCI;EACE,kCAAA;EACA,oCAAA;EACA,8CAAA;AAvCN;AA2CE;EACE,WAAA;EACA,uBAAA;AAzCJ;;AA6CA,qBAAA;AACA;EACE,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,yCAAA;AA1CF;;AA6CA,kBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,yCAAA;AA1CF;AA4CE;EACE,eAAA;EACA,YAAA;AA1CJ;AA6CE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA3CJ;;AA+CA,6EAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AA5CF;;AA+CA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AA5CF;;AA+CA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AA5CF;;AA+CA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,qCAAA;AA5CF;;AA+CA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;AA5CF;;AA+CA;EACE,eAAA;EACA,mBAAA;AA5CF;;AA+CA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,kBAAA;AA5CF;;AA+CA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AA5CF;;AA+CA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AA5CF;;AA+CA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AA5CF;;AA+CA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,oBAAA;EACA,+CAAA;AA5CF;;AA+CA;EACE,SAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AA5CF;;AA+CA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,kBAAA;AA5CF;;AA+CA;EACE,YAAA;AA5CF;;AA+CA;EACE,oBAAA;AA5CF;;AA+CA;EACE,mBAAA;AA5CF;;AA+CA,+DAAA;AACA;EACE,gBAAA;EACA,cAAA;EACA,MAAA;EACA,aAAA;EACA,oBAAA;AA5CF;;AA+CA;EACE,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,6CAAA;EACA,cAAA;AA5CF;AA8CE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AA5CJ;AA+CE;EACE,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;AA7CJ;AAgDE;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AA9CJ;AAiDE;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,4CAAA;AA/CJ;AAkDE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAhDJ;AAmDE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,qCAAA;AAjDJ;AAoDE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAlDJ;AAqDE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AAnDJ;AAqDI;;EAEE,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;AAnDN;AAsDI;;;EAGE,gBAAA;EACA,gBAAA;EACA,kCAAA;AApDN;AAuDI;EACE,gBAAA;EACA,cAAA;EACA,kCAAA;AArDN;;AA0DA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAvDF;;AA0DA,uBAAA;AACA;EACE;IACE,sBAAA;IACA,SAAA;IACA,uBAAA;EAvDF;EA0DA;IACE,UAAA;IACA,WAAA;EAxDF;EA2DA;IACE,gBAAA;IACA,YAAA;EAzDF;EA4DA;IACE,WAAA;EA1DF;AACF;AA6DA;EACE;IACE,0BAAA;IACA,SAAA;EA3DF;EA8DA;IACE,sBAAA;EA5DF;EA+DA;IACE,UAAA;IACA,eAAA;IACA,WAAA;EA7DF;EAgEA;IACE,gDAAA;EA9DF;EAiEA;;IAEE,mBAAA;EA/DF;AACF;AAkEA;EACE;IACE,sBAAA;IACA,SAAA;EAhEF;EAmEA;IACE,oBAAA;EAjEF;EAoEA;IACE,kBAAA;IACA,mBAAA;EAlEF;EAqEA;IACE,iBAAA;EAnEF;EAsEA;IACE,WAAA;IACA,eAAA;IACA,uBAAA;EApEF;AACF;AAuEA;;8EAAA;AAIA;EACE,eAAA;EACA,+BAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,6CAAA;AAtEF;;AAyEA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAtEF;;AAyEA;EACE,aAAA;EACA,qBAAA;EACA,eAAA;EACA,SAAA;AAtEF;;AAyEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAtEF;;AAyEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAtEF;AAwEE;EACE,kBAAA;EACA,kBAAA;AAtEJ;AAyEE;EACE,iBAAA;AAvEJ;;AA2EA,iCAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAxEF;;AA2EA;EACE,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,2DAAA;AAxEF;AA0EE;EACE,cAAA;AAxEJ;;AA4EA;EACE,gBAAA;EACA,cAAA;EACA,4CAAA;AAzEF;;AA4EA;EACE;+EAAA;EAEA,6BAAA;EACA,sBAAA;AAzEF;;AA4EA,oDAAA;AACA;EACE;gFAAA;EAEA,eAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6CAAA;EACA,iDAAA;AAzEF;AA2EE;EACE,UAAA;AAzEJ;AA2EE;EACE,qCAAA;EACA,kBAAA;AAzEJ;;AA6EA;EACE,gBAAA;EACA,WAAA;AA1EF;AA4EE;EACE,uBAAA;AA1EJ;AA6EE;EACE,uBAAA;EACA,aAAA;AA3EJ;;AA+EA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,oBAAA;AA5EF;;AA+EA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AA5EF;;AA+EA;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AA5EF;AA8EE;EACE,WAAA;EACA,qCAAA;AA5EJ;;AAgFA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA7EF;;AAgFA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;AA7EF;AA+EE;EACE,qCAAA;EACA,WAAA;AA7EJ;;AAiFA;EACE,6DAAA;EACA,WAAA;EACA,8CAAA;AA9EF;AAgFE;EACE,6DAAA;EACA,WAAA;AA9EJ;AAiFE;EACE,WAAA;AA/EJ;;AAmFA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAhFF;;AAmFA;EACE,mBAAA;AAhFF;;AAmFA,2DAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA;4EAAA;EAEA,kBAAA;EACA,oBAAA;EACA,wBAAA;AAhFF;AAkFE;EACE,UAAA;AAhFJ;AAkFE;EACE,kCAAA;EACA,kBAAA;AAhFJ;;AAoFA,2EAAA;AACA;EACE,sBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6CAAA;AAjFF;;AAoFA,6DAAA;AACA;EACE,kBAAA;AAjFF;;AAoFA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,wCAAA;EACA,oBAAA;EACA,qCAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,4CAAA;EACA,+EAAA;AAjFF;AAoFE;EACE,mCAAA;EACA,6CAAA;AAlFJ;;AAsFA;EACE,6DAAA;EACA,yBAAA;EACA,WAAA;EACA,8CAAA;AAnFF;AAqFE;EACE,yBAAA;EACA,6CAAA;AAnFJ;;AAuFA,iCAAA;AACA;EACE,gBAAA;EACA,gBAAA;AApFF;AAsFE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AApFJ;AAuFE;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AArFJ;AAwFE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAtFJ;AAyFE;EACE,mBAAA;AAvFJ;AAyFI;EACE,gBAAA;AAvFN;AA2FE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAzFJ;AA4FE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AA1FJ;AA6FE;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA3FJ;AA8FE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AA5FJ;AA+FE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AA7FJ;AAgGE;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AA9FJ;AAiGE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AA/FJ;AAiGI;;EAEE,iBAAA;EACA,gCAAA;EACA,mBAAA;AA/FN;AAkGI;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AAhGN;AAmGI;EACE,cAAA;AAjGN;AAoGI;EACE,mBAAA;AAlGN;;AAuGA,6DAAA;AACA;EACE;IACE,gBAAA;EApGF;EAuGA;IACE,gBAAA;IACA,SAAA;IACA,YAAA;IACA,WAAA;IACA,mBAAA;EArGF;EAwGA;IACE,WAAA;EAtGF;EAyGA;IACE,iBAAA;IACA,kBAAA;EAvGF;AACF","sourcesContent":["/* ─── ResultsView — Premium Editorial Layout ─── */\n\n.results {\n  width: full;\n  margin: 0;\n  padding: 0;\n  /* Opacity-only fade: a `transform` here would become the containing block for\n     the fixed rail / admin panel and make them scroll with the page. */\n  animation: resultsFadeIn 0.4s ease-out both;\n  position: relative;\n}\n\n@keyframes resultsFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* ─── 2-Column Layout: Sticky Sidebar + Main ─── */\n.layout {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  gap: 24px;\n  padding: 16px 20px 40px;\n  box-sizing: border-box;\n}\n\n/* ─── Sticky Left Sidebar ─── */\n.sidebar {\n  flex: 0 0 320px;\n  width: 320px;\n  align-self: stretch;\n  min-width: 0;\n  min-height: calc(100vh - var(--navbar-height, 64px) - 24px);\n}\n\n.sidebar-sticky {\n  position: sticky;\n  top: calc(var(--navbar-height, 64px) + 16px);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  height: calc(100vh - var(--navbar-height, 64px) - 24px);\n  padding-right: 4px;\n}\n\n.sidebar-head {\n  padding: 0 4px;\n}\n\n.sidebar-eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.6px;\n  text-transform: uppercase;\n  color: var(--accent-color, #0f3460);\n  opacity: 0.75;\n}\n\n/* ─── Right Main Content ─── */\n.main {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n/* ─── Overview / Ranking sub-tabs (Research Topics Overview mode) ─── */\n.overview-tabs {\n  min-height: 40px;\n  border-bottom: 1px solid rgba(15, 52, 96, 0.12);\n  margin-top: -16px;\n\n  :global(.MuiTabs-flexContainer) {\n    gap: 4px;\n  }\n}\n\n.overview-tabs-indicator {\n  background-color: #0f3460;\n  height: 2px;\n}\n\n.overview-tab {\n  min-height: 40px;\n  padding: 8px 22px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--grey-text, #64748b);\n\n  &--selected,\n  &:global(.Mui-selected) {\n    color: #0f3460 !important;\n  }\n}\n\n/* ─── Section 2: Benchmark Results ─── */\n.benchmark-results-section {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding-top: 24px;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.section-head {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.section-eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.4px;\n  text-transform: uppercase;\n  color: var(--accent-color, #0f3460);\n  opacity: 0.75;\n}\n\n.section-title {\n  margin: 0;\n  font-family: \"Lora\", \"Georgia\", serif;\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-1, #1a1a1a);\n}\n\n.section-subtitle {\n  margin: 0;\n  font-size: 13px;\n  color: var(--grey-text, #64748b);\n  line-height: 1.5;\n}\n\n/* ─── Empty Chart State ─── */\n.empty-chart-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 60px 24px;\n  background: var(--bg-2, #fff);\n  border: 1px dashed rgba(15, 52, 96, 0.18);\n  border-radius: 14px;\n  text-align: center;\n\n  &__icon {\n    color: var(--accent-color, #0f3460);\n    opacity: 0.5;\n  }\n\n  &__title {\n    margin: 0;\n    font-family: \"Lora\", \"Georgia\", serif;\n    font-size: 18px;\n    font-weight: 700;\n    color: var(--text-1, #1a1a1a);\n  }\n\n  &__text {\n    margin: 0;\n    max-width: 480px;\n    font-size: 13px;\n    color: var(--grey-text, #64748b);\n    line-height: 1.55;\n\n    strong {\n      color: var(--accent-color, #0f3460);\n    }\n  }\n}\n\n/* ─── Top Row: Filter + Charts side by side ─── */\n.top-row {\n  display: flex;\n  gap: 24px;\n  align-items: flex-start;\n}\n\n/* ─── Charts Column ─── */\n.charts-column {\n  flex: 0 0 65%;\n  max-width: 65%;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-width: 0;\n}\n\n/* ─── Bottom Section (full-width table) ─── */\n.bottom-section {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ─── Hero Header ─── */\n.hero {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 20px 16px 0;\n}\n\n/* ─── Divider ─── */\n.divider {\n  width: 100%;\n  height: 1px;\n  background: linear-gradient(90deg,\n      transparent 0%,\n      rgba(0, 0, 0, 0.08) 20%,\n      rgba(0, 0, 0, 0.08) 80%,\n      transparent 100%);\n}\n\n/* ─── Filter Bar (vertical, in sidebar) ─── */\n.filter-bar {\n  background: var(--bg-2, #fff);\n  border-radius: 14px;\n  padding: 20px 18px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100%;\n  overflow-y: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(15, 52, 96, 0.15);\n    border-radius: 4px;\n  }\n}\n\n/* ─── Mode RadioGroup ─── */\n.mode-radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  margin: 0;\n}\n\n.mode-radio-row {\n  margin: 0;\n  padding: 2px 0;\n}\n\n.mode-radio-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-1, #1a1a2e);\n  line-height: 1.3;\n}\n\n/* ─── Sidebar action buttons ─── */\n.sidebar-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: auto;\n  padding-top: 16px;\n  border-top: 1px solid rgba(15, 52, 96, 0.08);\n}\n\n.results-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.filter-label-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.filter-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.2px;\n  color: var(--accent-color, #0f3460);\n}\n\n.filter-hint {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: italic;\n  color: var(--grey-text, #999);\n}\n\n/* ─── Chip Search Bar ─── */\n.chip-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  width: 100%;\n  background: var(--bg-1, #fafafa);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 12px;\n  padding: 8px 12px;\n  align-content: flex-start;\n  transition: box-shadow 0.25s, border-color 0.25s;\n\n  &:focus-within {\n    border-color: rgba(15, 52, 96, 0.25);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n  }\n\n  &__icon {\n    flex-shrink: 0;\n    color: #94a3b8;\n  }\n\n  &__chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 5px 10px;\n    background: #0f3460;\n    color: #fff;\n    border-radius: 16px;\n    font-size: 12px;\n    font-weight: 600;\n    white-space: nowrap;\n    animation: chipIn 0.2s ease-out;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  &__chip-text {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n  }\n\n  &__chip-remove {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 14px;\n    height: 14px;\n    border: none;\n    background: rgba(255, 255, 255, 0.25);\n    color: #fff;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 1;\n    cursor: pointer;\n    transition: background 0.15s;\n    padding: 0;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.45);\n    }\n  }\n\n  &__input {\n    flex: 1 1 120px;\n    min-width: 120px;\n    border: none;\n    outline: none;\n    background: transparent;\n    font-size: 14px;\n    color: var(--text-1, #1a1a2e);\n    padding: 4px 2px;\n\n    &::placeholder {\n      color: #94a3b8;\n      font-weight: 400;\n    }\n  }\n\n  /* Suggestions dropdown */\n  &__suggestions {\n    position: absolute;\n    top: calc(100% + 4px);\n    left: 0;\n    right: 0;\n    background: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    border-radius: 12px;\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);\n    z-index: 100;\n    max-height: 220px;\n    overflow-y: auto;\n    padding: 4px;\n    animation: dropIn 0.15s ease-out;\n  }\n\n  &__suggestion-item {\n    display: block;\n    width: 100%;\n    text-align: left;\n    padding: 9px 12px;\n    border: none;\n    background: transparent;\n    font-size: 13px;\n    color: var(--text-1, #1a1a2e);\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background 0.12s;\n\n    &:hover {\n      background: rgba(15, 52, 96, 0.06);\n    }\n  }\n}\n\n/* ─── Back Button ─── */\n.back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 0;\n  border: none;\n  background: none;\n  color: var(--accent-color, #0f3460);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  align-self: flex-start;\n\n  &:hover {\n    opacity: 0.65;\n  }\n}\n\n/* ─── Analyze Button ─── */\n.analyze-btn {\n  align-self: stretch;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 22px;\n  border-radius: 12px;\n  border: none;\n  background: linear-gradient(135deg, #1e3a5f 0%, #0f3460 100%);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 14px rgba(15, 52, 96, 0.2);\n\n  &:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 22px rgba(15, 52, 96, 0.35);\n    filter: brightness(1.1);\n  }\n\n  &:active:not(:disabled) {\n    transform: translateY(0);\n    box-shadow: 0 2px 8px rgba(15, 52, 96, 0.2);\n  }\n\n  &:disabled {\n    background: #e8e8e8;\n    color: #aaa;\n    cursor: not-allowed;\n    box-shadow: none;\n  }\n}\n\n/* ─── Spin ─── */\n.spin {\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes chipIn {\n  from {\n    opacity: 0;\n    transform: scale(0.85);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes dropIn {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n\n\n/* ─── Export Bar ─── */\n.export-bar {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.export-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 9px 18px;\n  border-radius: 10px;\n  border: 1px solid rgba(15, 52, 96, 0.15);\n  background: rgba(15, 52, 96, 0.04);\n  color: #0f3460;\n  font-size: 12.5px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n\n  &:hover:not(:disabled) {\n    background: rgba(15, 52, 96, 0.1);\n    border-color: rgba(15, 52, 96, 0.25);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(15, 52, 96, 0.12);\n  }\n\n  &:active:not(:disabled) {\n    transform: translateY(0);\n    box-shadow: none;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &--excel {\n    border-color: rgba(16, 124, 65, 0.2);\n    background: rgba(16, 124, 65, 0.04);\n    color: #107c41;\n\n    &:hover:not(:disabled) {\n      background: rgba(16, 124, 65, 0.1);\n      border-color: rgba(16, 124, 65, 0.3);\n      box-shadow: 0 4px 12px rgba(16, 124, 65, 0.12);\n    }\n  }\n\n  &--full {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* ─── Skeleton ─── */\n.skeleton-wrapper {\n  padding: 32px 28px;\n  background: var(--bg-2, #fff);\n  border-radius: 14px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\n}\n\n/* ─── Error ─── */\n.error-msg {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 60px 20px;\n  text-align: center;\n  background: var(--bg-2, #fff);\n  border-radius: 14px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\n\n  &__icon {\n    font-size: 32px;\n    opacity: 0.6;\n  }\n\n  &__text {\n    color: #ff4d4f;\n    font-size: 14px;\n    font-weight: 500;\n  }\n}\n\n/* Inter-Institutional Metric Scaling: title → full-name legend → bar + pie */\n.benchmark-scaling-head {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.benchmark-scaling-legend {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px 20px;\n}\n\n.benchmark-scaling-legend__item {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.benchmark-scaling-legend__swatch {\n  width: 14px;\n  height: 14px;\n  border-radius: 2px;\n  flex-shrink: 0;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.benchmark-scaling-legend__name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-1, #333);\n  line-height: 1.35;\n}\n\n.scaling-chart-block {\n  margin-top: 4px;\n  margin-bottom: 24px;\n}\n\n.scaling-chart-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 20px;\n  align-items: start;\n}\n\n.scaling-chart-block__label {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #0f3460;\n}\n\n.chart-viz-tabpane {\n  padding-top: 10px;\n  font-size: 15px;\n  color: #0f3460;\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n.advanced-benchmark {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  margin-top: 2px;\n}\n\n.advanced-benchmark__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(15, 52, 96, 0.08);\n}\n\n.advanced-benchmark__title {\n  margin: 0;\n  font-family: \"Lora\", \"Georgia\", serif;\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-1, #1a1a1a);\n}\n\n.advanced-benchmark__grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 20px;\n  align-items: start;\n}\n\n.advanced-benchmark__split-cell {\n  min-width: 0;\n}\n\n.advanced-benchmark__item--wide {\n  grid-column: span 12;\n}\n\n.advanced-benchmark__item--half {\n  grid-column: span 6;\n}\n\n/* Off-screen PDF capture (html2canvas); not visible to users */\n.pdf-capture-host {\n  position: sticky;\n  left: -20000px;\n  top: 0;\n  width: 1200px;\n  pointer-events: none;\n}\n\n.pdf-summary {\n  background: #fff;\n  padding: 28px 32px 36px;\n  box-sizing: border-box;\n  font-family: \"Poppins\", system-ui, sans-serif;\n  color: #1a1a1a;\n\n  &__intro {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-bottom: 28px;\n  }\n\n  &__title {\n    font-family: \"Lora\", \"Georgia\", serif;\n    font-size: 22px;\n    font-weight: 700;\n    margin: 0;\n    color: #1a1a1a;\n  }\n\n  &__subtitle {\n    margin: 0;\n    font-size: 13px;\n    color: #666;\n    line-height: 1.45;\n    max-width: 720px;\n  }\n\n  &__legend {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px 20px;\n    margin-bottom: 28px;\n    padding-top: 4px;\n    padding-bottom: 24px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  }\n\n  &__legend-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    max-width: 100%;\n  }\n\n  &__swatch {\n    width: 16px;\n    height: 16px;\n    border-radius: 3px;\n    flex-shrink: 0;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n  }\n\n  &__legend-name {\n    font-size: 14px;\n    font-weight: 600;\n    color: #0f3460;\n    line-height: 1.3;\n  }\n\n  &__table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 12px;\n    table-layout: fixed;\n\n    th,\n    td {\n      border: 1px solid rgba(0, 0, 0, 0.1);\n      padding: 10px 12px;\n      text-align: right;\n      vertical-align: top;\n      word-wrap: break-word;\n    }\n\n    th[scope=\"col\"]:first-child,\n    th[scope=\"row\"],\n    td:first-child {\n      text-align: left;\n      font-weight: 600;\n      background: rgba(15, 52, 96, 0.04);\n    }\n\n    thead th {\n      font-weight: 700;\n      color: #0f3460;\n      background: rgba(15, 52, 96, 0.08);\n    }\n  }\n}\n\n.pdf-pie-capture {\n  width: 100%;\n  max-width: 1200px;\n  background: #fff;\n  box-sizing: border-box;\n}\n\n/* ─── Responsive ─── */\n@media only screen and (max-width: 1100px) {\n  .layout {\n    flex-direction: column;\n    gap: 20px;\n    padding: 12px 16px 32px;\n  }\n\n  .sidebar {\n    flex: none;\n    width: 100%;\n  }\n\n  .sidebar-sticky {\n    position: static;\n    height: auto;\n  }\n\n  .main {\n    width: 100%;\n  }\n}\n\n@media only screen and (max-width: 960px) {\n  .scaling-chart-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .top-row {\n    flex-direction: column;\n  }\n\n  .charts-column {\n    flex: none;\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .advanced-benchmark__grid {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n\n  .advanced-benchmark__item--wide,\n  .advanced-benchmark__item--half {\n    grid-column: span 6;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .layout {\n    padding: 8px 12px 24px;\n    gap: 16px;\n  }\n\n  .hero {\n    padding: 12px 12px 0;\n  }\n\n  .filter-bar {\n    padding: 16px 14px;\n    border-radius: 12px;\n  }\n\n  .chip-search {\n    padding: 6px 10px;\n  }\n\n  .analyze-btn {\n    width: 100%;\n    max-width: none;\n    justify-content: center;\n  }\n}\n\n/* ─────────────────────────────────────────────────────────────────────────\n   Revamped layout: sticky header + collapsible mode rail + floating pair panel\n   ───────────────────────────────────────────────────────────────────────── */\n\n.topbar {\n  position: fixed;\n  top: var(--navbar-height, 60px);\n  left: 0;\n  right: 0;\n  z-index: 20;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 16px 24px;\n  padding: 14px 20px;\n  background: #fff;\n  border-bottom: 1px solid #e5e7eb;\n  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.05);\n}\n\n.topbar__topics {\n  flex: 1 1 420px;\n  min-width: 260px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.topbar__controls {\n  display: flex;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.topbar__group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.topbar__actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  .analyze-btn {\n    align-self: center;\n    padding: 10px 20px;\n  }\n\n  .export-btn {\n    padding: 9px 14px;\n  }\n}\n\n/* Segmented time-range control */\n.timeseg {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 3px;\n  background: #eef2f6;\n  border-radius: 10px;\n}\n\n.timeseg__btn {\n  border: none;\n  background: transparent;\n  padding: 7px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #64748b;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s, color 0.15s, box-shadow 0.15s;\n\n  &:hover {\n    color: #0f3460;\n  }\n}\n\n.timeseg__btn--active {\n  background: #fff;\n  color: #0f3460;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.14);\n}\n\n.workspace {\n  /* Header is sticky (in flow) so it needs no top offset; the left offset (set\n     inline = rail width + gap) clears the fixed rail. 316px is the fallback. */\n  padding: 24px 20px 48px 316px;\n  box-sizing: border-box;\n}\n\n/* ─── Benchmark-mode rail (dark, collapsible) ─── */\n.rail {\n  /* Fixed to the viewport (below the fixed topbar). Exact top/height are set\n     inline from the measured header height so it clears the header precisely. */\n  position: fixed;\n  left: 20px;\n  top: 180px;\n  z-index: 15;\n  width: 272px;\n  height: calc(100vh - 220px);\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 10px;\n  background: #0f2138;\n  border-radius: 14px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.14);\n  transition: flex-basis 0.2s ease, width 0.2s ease;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.15);\n    border-radius: 4px;\n  }\n}\n\n.rail--collapsed {\n  flex-basis: 68px;\n  width: 68px;\n\n  .rail__head {\n    justify-content: center;\n  }\n\n  .rail__item {\n    justify-content: center;\n    padding: 10px;\n  }\n}\n\n.rail__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 4px 6px 8px;\n}\n\n.rail__eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.4px;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.rail__toggle {\n  margin-left: auto;\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 3px 7px;\n  border-radius: 6px;\n  transition: background 0.15s, color 0.15s;\n\n  &:hover {\n    color: #fff;\n    background: rgba(255, 255, 255, 0.08);\n  }\n}\n\n.rail__list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.rail__item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 10px;\n  color: #cbd5e1;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.06);\n    color: #fff;\n  }\n}\n\n.rail__item--active {\n  background: linear-gradient(135deg, #f0703a 0%, #e8622c 100%);\n  color: #fff;\n  box-shadow: 0 6px 16px rgba(232, 98, 44, 0.35);\n\n  &:hover {\n    background: linear-gradient(135deg, #f0703a 0%, #e8622c 100%);\n    color: #fff;\n  }\n\n  .rail__icon {\n    color: #fff;\n  }\n}\n\n.rail__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  color: #94a3b8;\n}\n\n.rail__label {\n  white-space: nowrap;\n}\n\n/* ─── Results column: pair picker (own row) + charts ─── */\n.content-col {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-width: 0;\n  width: 100%;\n  /* Padding so charts don't sit flush against the scrollbar when this column\n     becomes the bounded scroll container (inline height on wide screens). */\n  padding-right: 4px;\n  padding-bottom: 24px;\n  scrollbar-gutter: stable;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: rgba(15, 52, 96, 0.18);\n    border-radius: 4px;\n  }\n}\n\n/* Pair-entity picker card — its own row, aligned with the results column */\n.pair-panel {\n  align-self: flex-start;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 16px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);\n}\n\n/* ─── Report builder: per-chart \"Add to report\" toggle ─── */\n.reportable {\n  position: relative;\n}\n\n.report-toggle {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  z-index: 6;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 11px;\n  border: 1px solid rgba(15, 52, 96, 0.22);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(2px);\n  color: #0f3460;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  cursor: pointer;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);\n  transition: background 0.15s, border-color 0.15s, color 0.15s,\n    box-shadow 0.15s;\n\n  &:hover {\n    border-color: rgba(15, 52, 96, 0.4);\n    box-shadow: 0 3px 10px rgba(15, 23, 42, 0.12);\n  }\n}\n\n.report-toggle--on {\n  background: linear-gradient(135deg, #f0703a 0%, #e8622c 100%);\n  border-color: transparent;\n  color: #fff;\n  box-shadow: 0 4px 12px rgba(232, 98, 44, 0.32);\n\n  &:hover {\n    border-color: transparent;\n    box-shadow: 0 5px 14px rgba(232, 98, 44, 0.4);\n  }\n}\n\n/* ─── Report preview modal ─── */\n.report-preview {\n  max-height: 62vh;\n  overflow-y: auto;\n\n  &__loading {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    padding: 48px 0;\n    color: #64748b;\n    font-size: 14px;\n  }\n\n  &__empty {\n    padding: 40px 0;\n    text-align: center;\n    color: #64748b;\n    font-size: 14px;\n  }\n\n  &__hint {\n    margin: 0 0 16px;\n    font-size: 13px;\n    color: #64748b;\n    line-height: 1.5;\n  }\n\n  &__item {\n    margin-bottom: 20px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  &__item-title {\n    margin-bottom: 6px;\n    font-size: 13px;\n    font-weight: 700;\n    color: #1e293b;\n  }\n\n  &__img {\n    display: block;\n    width: 100%;\n    height: auto;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n  }\n\n  &__legend {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px 16px;\n    margin-top: 10px;\n  }\n\n  &__legend-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    color: #475569;\n  }\n\n  &__legend-swatch {\n    width: 11px;\n    height: 11px;\n    border-radius: 3px;\n    flex-shrink: 0;\n  }\n\n  &__table-wrap {\n    margin-top: 10px;\n    overflow-x: auto;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n  }\n\n  &__table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 12px;\n\n    th,\n    td {\n      padding: 7px 10px;\n      border-bottom: 1px solid #eef2f6;\n      white-space: nowrap;\n    }\n\n    th {\n      background: #f8fafc;\n      font-weight: 700;\n      color: #334155;\n    }\n\n    td {\n      color: #475569;\n    }\n\n    tr:last-child td {\n      border-bottom: none;\n    }\n  }\n}\n\n/* Small screens: unpin the header + rail, drop the offsets */\n@media only screen and (max-width: 960px) {\n  .topbar {\n    position: static;\n  }\n\n  .rail {\n    position: static;\n    top: auto;\n    height: auto;\n    width: 100%;\n    margin-bottom: 16px;\n  }\n\n  .rail--collapsed {\n    width: 100%;\n  }\n\n  .workspace {\n    padding-top: 20px;\n    padding-left: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"results": `ResultsView_results__aXu+3`,
	"resultsFadeIn": `ResultsView_resultsFadeIn__SRSjy`,
	"layout": `ResultsView_layout__y0Mmy`,
	"sidebar": `ResultsView_sidebar__Wdw9+`,
	"sidebar-sticky": `ResultsView_sidebar-sticky__bgfnJ`,
	"sidebar-head": `ResultsView_sidebar-head__Xyk5e`,
	"sidebar-eyebrow": `ResultsView_sidebar-eyebrow__0zl6p`,
	"main": `ResultsView_main__W4UCN`,
	"overview-tabs": `ResultsView_overview-tabs__J9t8U`,
	"overview-tabs-indicator": `ResultsView_overview-tabs-indicator__fOBVW`,
	"overview-tab": `ResultsView_overview-tab__9Glpy`,
	"overview-tab--selected": `ResultsView_overview-tab--selected__vVtiU`,
	"benchmark-results-section": `ResultsView_benchmark-results-section__tv4dT`,
	"section-head": `ResultsView_section-head__E65Pg`,
	"section-eyebrow": `ResultsView_section-eyebrow__72Wbp`,
	"section-title": `ResultsView_section-title__7zzaI`,
	"section-subtitle": `ResultsView_section-subtitle__jtuS3`,
	"empty-chart-state": `ResultsView_empty-chart-state__u4dgn`,
	"empty-chart-state__icon": `ResultsView_empty-chart-state__icon__jENG5`,
	"empty-chart-state__title": `ResultsView_empty-chart-state__title__OTv0f`,
	"empty-chart-state__text": `ResultsView_empty-chart-state__text__OnxBu`,
	"top-row": `ResultsView_top-row__pi0rJ`,
	"charts-column": `ResultsView_charts-column__Namsd`,
	"bottom-section": `ResultsView_bottom-section__wgkEo`,
	"hero": `ResultsView_hero__kydjT`,
	"divider": `ResultsView_divider__A-m+6`,
	"filter-bar": `ResultsView_filter-bar__LgDLl`,
	"mode-radio-group": `ResultsView_mode-radio-group__DitTQ`,
	"mode-radio-row": `ResultsView_mode-radio-row__Rs3+n`,
	"mode-radio-label": `ResultsView_mode-radio-label__S-Lbg`,
	"sidebar-actions": `ResultsView_sidebar-actions__HED3o`,
	"results-wrapper": `ResultsView_results-wrapper__EsJEJ`,
	"filter-group": `ResultsView_filter-group__uOpbj`,
	"filter-label-row": `ResultsView_filter-label-row__AahgE`,
	"filter-label": `ResultsView_filter-label__Uil7E`,
	"filter-hint": `ResultsView_filter-hint__2Ekps`,
	"chip-search": `ResultsView_chip-search__zqAM0`,
	"chip-search__icon": `ResultsView_chip-search__icon__yi9pY`,
	"chip-search__chip": `ResultsView_chip-search__chip__-3oU7`,
	"chipIn": `ResultsView_chipIn__nNJqU`,
	"chip-search__chip-text": `ResultsView_chip-search__chip-text__fgxwP`,
	"chip-search__chip-remove": `ResultsView_chip-search__chip-remove__zcKuS`,
	"chip-search__input": `ResultsView_chip-search__input__L6GBD`,
	"chip-search__suggestions": `ResultsView_chip-search__suggestions__S9GG+`,
	"dropIn": `ResultsView_dropIn__3wgbn`,
	"chip-search__suggestion-item": `ResultsView_chip-search__suggestion-item__d1pgc`,
	"back-btn": `ResultsView_back-btn__4ET9p`,
	"analyze-btn": `ResultsView_analyze-btn__iVja6`,
	"spin": `ResultsView_spin__1C9es`,
	"export-bar": `ResultsView_export-bar__V5Jik`,
	"export-btn": `ResultsView_export-btn__MGdQ6`,
	"export-btn--excel": `ResultsView_export-btn--excel__JX4E-`,
	"export-btn--full": `ResultsView_export-btn--full__dGWIQ`,
	"skeleton-wrapper": `ResultsView_skeleton-wrapper__36SQy`,
	"error-msg": `ResultsView_error-msg__taIXW`,
	"error-msg__icon": `ResultsView_error-msg__icon__-ByLq`,
	"error-msg__text": `ResultsView_error-msg__text__VOM8E`,
	"benchmark-scaling-head": `ResultsView_benchmark-scaling-head__f3Ihs`,
	"benchmark-scaling-legend": `ResultsView_benchmark-scaling-legend__uZgtO`,
	"benchmark-scaling-legend__item": `ResultsView_benchmark-scaling-legend__item__ZlL8M`,
	"benchmark-scaling-legend__swatch": `ResultsView_benchmark-scaling-legend__swatch__hpLlM`,
	"benchmark-scaling-legend__name": `ResultsView_benchmark-scaling-legend__name__2K+gA`,
	"scaling-chart-block": `ResultsView_scaling-chart-block__W6wyR`,
	"scaling-chart-grid": `ResultsView_scaling-chart-grid__3M+Q+`,
	"scaling-chart-block__label": `ResultsView_scaling-chart-block__label__BUGee`,
	"chart-viz-tabpane": `ResultsView_chart-viz-tabpane__zzbhU`,
	"advanced-benchmark": `ResultsView_advanced-benchmark__1HO4Q`,
	"advanced-benchmark__head": `ResultsView_advanced-benchmark__head__+r2zw`,
	"advanced-benchmark__title": `ResultsView_advanced-benchmark__title__6g-rF`,
	"advanced-benchmark__grid": `ResultsView_advanced-benchmark__grid__u8CyJ`,
	"advanced-benchmark__split-cell": `ResultsView_advanced-benchmark__split-cell__OIV7A`,
	"advanced-benchmark__item--wide": `ResultsView_advanced-benchmark__item--wide__IZvoL`,
	"advanced-benchmark__item--half": `ResultsView_advanced-benchmark__item--half__xkXjO`,
	"pdf-capture-host": `ResultsView_pdf-capture-host__V9jYP`,
	"pdf-summary": `ResultsView_pdf-summary__Zzx9K`,
	"pdf-summary__intro": `ResultsView_pdf-summary__intro__rxXBe`,
	"pdf-summary__title": `ResultsView_pdf-summary__title__VII4d`,
	"pdf-summary__subtitle": `ResultsView_pdf-summary__subtitle__cMxvd`,
	"pdf-summary__legend": `ResultsView_pdf-summary__legend__CYZYq`,
	"pdf-summary__legend-item": `ResultsView_pdf-summary__legend-item__tD3gp`,
	"pdf-summary__swatch": `ResultsView_pdf-summary__swatch__gcTYD`,
	"pdf-summary__legend-name": `ResultsView_pdf-summary__legend-name__KA+m4`,
	"pdf-summary__table": `ResultsView_pdf-summary__table__NTpNv`,
	"pdf-pie-capture": `ResultsView_pdf-pie-capture__aQnVk`,
	"topbar": `ResultsView_topbar__heiyu`,
	"topbar__topics": `ResultsView_topbar__topics__v1248`,
	"topbar__controls": `ResultsView_topbar__controls__DCSWX`,
	"topbar__group": `ResultsView_topbar__group__8foQd`,
	"topbar__actions": `ResultsView_topbar__actions__jehXw`,
	"timeseg": `ResultsView_timeseg__V-nN8`,
	"timeseg__btn": `ResultsView_timeseg__btn__weffX`,
	"timeseg__btn--active": `ResultsView_timeseg__btn--active__gOca1`,
	"workspace": `ResultsView_workspace__iBsIt`,
	"rail": `ResultsView_rail__xTTVi`,
	"rail--collapsed": `ResultsView_rail--collapsed__Sw-mW`,
	"rail__head": `ResultsView_rail__head__6DmpZ`,
	"rail__item": `ResultsView_rail__item__MycCH`,
	"rail__eyebrow": `ResultsView_rail__eyebrow__YPRvO`,
	"rail__toggle": `ResultsView_rail__toggle__8chB1`,
	"rail__list": `ResultsView_rail__list__z7dff`,
	"rail__item--active": `ResultsView_rail__item--active__RpiLV`,
	"rail__icon": `ResultsView_rail__icon__ZWpOe`,
	"rail__label": `ResultsView_rail__label__wc3ws`,
	"content-col": `ResultsView_content-col__sOY+O`,
	"pair-panel": `ResultsView_pair-panel__V-gsI`,
	"reportable": `ResultsView_reportable__7NcW4`,
	"report-toggle": `ResultsView_report-toggle__Sq2Jc`,
	"report-toggle--on": `ResultsView_report-toggle--on__DRldb`,
	"report-preview": `ResultsView_report-preview__kHYAX`,
	"report-preview__loading": `ResultsView_report-preview__loading__brFJx`,
	"report-preview__empty": `ResultsView_report-preview__empty__E8FCK`,
	"report-preview__hint": `ResultsView_report-preview__hint__8jFer`,
	"report-preview__item": `ResultsView_report-preview__item__lEIcq`,
	"report-preview__item-title": `ResultsView_report-preview__item-title__STzcR`,
	"report-preview__img": `ResultsView_report-preview__img__egLdz`,
	"report-preview__legend": `ResultsView_report-preview__legend__VEUJx`,
	"report-preview__legend-item": `ResultsView_report-preview__legend-item__WhzQR`,
	"report-preview__legend-swatch": `ResultsView_report-preview__legend-swatch__Lh9JF`,
	"report-preview__table-wrap": `ResultsView_report-preview__table-wrap__lx+f1`,
	"report-preview__table": `ResultsView_report-preview__table__XlK6O`,
	"fadeIn": `ResultsView_fadeIn__7wb9m`
};
export default ___CSS_LOADER_EXPORT___;
